export enum NotificationSubpage {
    Announcements,
    NotificationsFromTeachers,
}
